module.exports = __webpack_public_path__ + "img/story-header.f5996132.jpg";